<template>
  <div class="logout" v-loading="true">
    <div class="content">
      <h1>Cerrando sesión</h1>
      <img src="@/img/undraw_quitting_time_dm-8-t.svg" />
    </div>
  </div>
</template>

<script>
import * as Sentry from "@sentry/vue"
import {mapActions } from 'vuex';
export default {
  computed: {
    user() {
      return this.$store.getters['getUser']
    }
  },
  methods: {
    ...mapActions(['updateStatus','setDefaultValues','signOut']),
    async doLogout() {
      Sentry.setUser(null);
      try {
        if (this.user) {
          await this.updateStatus("disconnected")
        }
        await this.signOut();
      } catch (error) {
        console.log(error);
      }finally{
        if('mode' in this.$route.query){
          window.location.href = '/auth/login?mode=widget'
        }else{
          window.location.href = '/auth/login'
        }
      }
    }
  },
  created() {
    setTimeout(() => {
      this.doLogout();
    }, 5000)
  },
  mounted() {
		this.$title = this.$t("user-buttons.logout")
	}
}
</script>

<style scoped>
.logout {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
img {
	width: 30em;
}

h1 {
  text-align: center;
  margin-bottom: var(--column);
}

.content {
  background: white;
  border-radius: var(--radius);
  padding: calc(var(--column) * 3);
}
</style>